import { Link } from "gatsby";
import { RiHeart2Line } from "react-icons/ri";
import * as React from 'react';
export default {
  Link,
  RiHeart2Line,
  React
};